export const SPECIAL_ANSWER_FIELD_IDS = {
  NONE: 'none' as const,
  SKIP: 'skip' as const,
  NA: 'na' as const,
}
